import { render } from "./detail.vue?vue&type=template&id=e19df980"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
script.render = render

export default script